"use client";

import DebugScript from "@/components/DebugScript";
import Maintenance from "@/components/Maintenance";
import AuthProvider from "@/contexts/Auth";
import GlobalDataProvider from "@/contexts/GlobalData";
import Monitor from "@/contexts/Monitor";
import TheNextUIProviders from "@/contexts/NextUi";
import NotifyProvider from "@/contexts/NotifyProvider";
import PocketBaseDataProvider from "@/contexts/Pocketbase";
import RealtimeData from "@/contexts/RealtimeData";
import AppLayout from "@/layouts/AppLayout";
import { TonConnectUIProvider } from "@tonconnect/ui-react";
import { CookiesProvider } from "react-cookie";
import "./clash-display.css";
import "./globals.css";
import "./SFProDisplay.css";
import { Viewport } from "next";
import telegramAnalytics from "@telegram-apps/analytics";
import PresaleDataProvider from "@/contexts/Presale";
import { useRef } from "react";
// import clsx from "clsx";
export const viewport: Viewport = {
  width: "device-width",
  initialScale: 1,
  maximumScale: 1,
  userScalable: false
  // Also supported by less commonly used
  // interactiveWidget: 'resizes-visual',
};
export default function RootLayout({
  children
}: Readonly<{
  children: React.ReactNode;
}>) {
  const firstRender = useRef(true);
  if (firstRender.current) {
    firstRender.current = false;
    try {
      telegramAnalytics.init({
        token: process.env.NEXT_PUBLIC_TELEGRAM_ANALYTICS_TOKEN || "",
        // SDK Auth token received via @DataChief_bot
        appName: process.env.NEXT_PUBLIC_TELEGRAM_ANALYTICS_APP_NAME || "" // The analytics identifier you entered in @DataChief_bot
      });
    } catch (error) {
      console.log(error);
    }
  }
  return <html lang="en" data-sentry-component="RootLayout" data-sentry-source-file="layout.tsx">
            <head>
                <title>TBK</title>
                <link rel="preload" href="/images/main_bg.jpg" as="image" />
            </head>
            <body className="!select-none">
                <Monitor data-sentry-element="Monitor" data-sentry-source-file="layout.tsx">
                    {process.env.NEXT_PUBLIC_MAINTENANCE && process.env.NEXT_PUBLIC_MAINTENANCE == "true" ? <Maintenance /> : <TonConnectUIProvider manifestUrl={process.env.NEXT_PUBLIC_MANIFEST_URL} actionsConfiguration={{
          twaReturnUrl: `https://${process.env.NEXT_PUBLIC_RETURN_URL}?startapp=connected`
        }}>
                            <TheNextUIProviders>
                                <CookiesProvider defaultSetOptions={{
              path: "/",
              maxAge: 24 * 60 * 60
            }}>
                                    <GlobalDataProvider>
                                        <AuthProvider>
                                            <RealtimeData>
                                                <NotifyProvider>
                                                    <PocketBaseDataProvider>
                                                        <AppLayout>{children}</AppLayout>
                                                    </PocketBaseDataProvider>
                                                </NotifyProvider>
                                            </RealtimeData>
                                        </AuthProvider>
                                    </GlobalDataProvider>
                                </CookiesProvider>
                            </TheNextUIProviders>
                        </TonConnectUIProvider>}
                </Monitor>
                <DebugScript data-sentry-element="DebugScript" data-sentry-source-file="layout.tsx" />
            </body>
        </html>;
}